import {CampaignJourneyWSchema} from '@cohort/wallet-schemas/campaign';
import {MerchantWSchema} from '@cohort/wallet-schemas/merchant';
import {OrderWSchema} from '@cohort/wallet-schemas/order';
import {OwnershipWSchema} from '@cohort/wallet-schemas/ownership';
import {PerkWSchema} from '@cohort/wallet-schemas/perk';
import {PerkAccessWSchema} from '@cohort/wallet-schemas/perkAccess';
import {z} from 'zod';

export const PerkSpaceViewWSchema = z.object({
  perk: PerkWSchema,
  instances: z.array(PerkAccessWSchema),
});
export type PerkSpaceViewWDto = z.infer<typeof PerkSpaceViewWSchema>;

export const SpaceWSchema = z.object({
  merchant: MerchantWSchema,
  digitalAssetCount: z.number().int().min(0).optional(),
  activeOwnerships: z.array(OwnershipWSchema),
  pendingOrders: z.array(OrderWSchema),
  perks: z.array(PerkSpaceViewWSchema),
  journeys: z.array(CampaignJourneyWSchema),
});
export type SpaceWDto = z.infer<typeof SpaceWSchema>;

export const SyncSpaceResultWSchema = z.object({
  newOwnershipsFound: z.boolean(),
});
export type SyncSpaceResultWDto = z.infer<typeof SyncSpaceResultWSchema>;

export const UserWalletWSchema = z.object({
  merchantSpaces: z.array(SpaceWSchema),
});
export type UserWalletWDto = z.infer<typeof UserWalletWSchema>;
